
import { useState, useEffect } from 'react'
import Swiper from 'swiper'
import React from 'react'

export default function Center(props) {
  const [ifon, setIfon] = useState({
    center: null
  })

  useEffect(() => {
    //  var cw = (ww - 1120) / 2;
    const example = new Swiper('.Center', {
      loop: true, // 循环模式选项
      autoplay: true,
      slidesPerView: 2,
      spaceBetween: 15,
      centeredSlides: true,
      direction: 'horizontal',
      speed: props.playbackSpeed
      /* slidesOffsetBefore: 15,
            slidesOffsetAfter: 15 */
    })

    setIfon({
      ...ifon,
      center: example
    })

    return () => {
      example.destroy && example.destroy()
    }
  }, [])

  useEffect(() => {
    ifon.center && (ifon.center.params.speed = props.playbackSpeed)
  }, [props.playbackSpeed])

  return (<div className='Center'>
    <div class='swiper-wrapper'>
      {props.ifon.image_id_list.map((item) => {
        return <div class='swiper-slide' key={item.id}>
          <img className='slide_img' src={item.src}></img>
        </div>
      })}
    </div>
  </div>)
}
console.log(React)
